import { createContext, useContext, useMemo, useState } from "react"
import { useNavigate } from "react-router"

const NavigationContext = createContext({
	push: () => {
		throw Error("if you want to use the navigation please wrap in an NavigationHandler")
	},
	replace: () => {
		throw Error("if you want to use the navigation please wrap in an NavigationHandler")
	},
	pop: () => {
		throw Error("if you want to use the navigation please wrap in an NavigationHandler")
	},
	action: null,
	animation: null,
})

const NavigationHandler = ({ children }) => {
	const navigate = useNavigate()
	/**
	 * The inital value must be an animation otherwise the first page dont get removed after the first transition because motion.div would have no animation to handle
	 */
	const [navigationAction, setNavigationAction] = useState({
		action: "PUSH",
		animation: "slide",
		data: {},
		index: 0,
	})

	const push = (to, animation, data) => {
		setNavigationAction({
			action: "PUSH",
			animation,
			data,
			index: navigationAction.index + 1,
		})
		navigate(to)
	}
	/**
	 *
	 * @param {*} to
	 * @param {*} animation
	 * @param {*} data
	 * @param {'POP' | 'PUSH' | 'REPLACE'} customAction Defines a custom action to be used in the animations. So we can force a POP Animation without doing a Pop.
	 */
	const replace = (to, animation, data, customAction) => {
		setNavigationAction({
			action: customAction || "REPLACE",
			animation,
			data,
			index: navigationAction.index,
		})
		navigate(to, { replace: true })
	}
	//TODO Hold a stack of the visited routes (push,replace,pop)
	//and then implement it that we can pop to a specific page if it is in our stack so that we know that we need to pop 2 routes
	//need it if we want to reset the password.. then the pop will lead to the loginpage also but without the params

	/**
	 * Go a page back. If the HistoryIndex is 0 (we never saw a other page before) we will jump to the default startPath "/"
	 * @param {*} number
	 * @param {*} animation
	 * @param {*} data
	 */
	const pop = (number, animation, data) => {
		//if want to make a pop but the history index is 0 then we go to the default Page because we can't go back further
		if (navigationAction.index === 0) {
			number = "/"
		}

		setNavigationAction({
			action: "POP",
			animation,
			data,
			index: navigationAction.index === 0 ? 0 : navigationAction.index - 1,
		})

		navigate(number)
	}

	const contextValue = useMemo(() => {
		return {
			push,
			replace,
			pop,
			action: navigationAction.action,
			animation: navigationAction.animation,
			data: navigationAction.data,
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [navigationAction])

	return <NavigationContext.Provider value={contextValue}>{children}</NavigationContext.Provider>
}

const useCustomNavigation = () => {
	return useContext(NavigationContext)
}

const useNavigationData = () => {
	return useContext(NavigationContext).data
}

export { NavigationContext, NavigationHandler, useCustomNavigation, useNavigationData }
